import {
  allowedLlmGatewayModels,
  fetchLlmGatewayConfiguration,
  fetchLlmGatewayModels,
  selectLlmGatewayConfiguration,
} from "@app/deploy";
import { selectOrganizationSelectedId } from "@app/organizations";
import { useLoader, useQuery, useSelector } from "@app/react";
import type { DeployLlmGatewayModel } from "@app/types";
import { Banner, Group, tokens } from "../shared";
import { LlmGatewayModelTable } from "../shared/llm-gateway-model/llm-gateway-model-table";
import { EditPolicyLink } from "../shared/llm-gateway-policy/edit-policy-link";

export const LlmGatewayKeyModelsPage = () => {
  const orgId = useSelector(selectOrganizationSelectedId);
  const configLoader = useQuery(fetchLlmGatewayConfiguration({ orgId }));
  useQuery(fetchLlmGatewayModels());

  const config = useSelector(selectLlmGatewayConfiguration);
  const modelsLoader = useLoader(fetchLlmGatewayModels);
  const catalog: DeployLlmGatewayModel[] = modelsLoader.meta.models || [];
  const models = allowedLlmGatewayModels(config ? config.models : [], catalog);
  const isCatalogLoading =
    modelsLoader.isLoading || modelsLoader.isInitialLoading;

  return (
    <Group>
      <p className={tokens.type.darker}>
        The models this key can call, as set by your organization's model
        allowlist. <EditPolicyLink />
      </p>

      {!isCatalogLoading && catalog.length === 0 ? (
        <Banner variant="error">
          We couldn't load the list of supported models.
        </Banner>
      ) : null}

      {/* Until the config loads, an empty allowlist would read as unrestricted. */}
      <LlmGatewayModelTable
        rowData={config ? models : []}
        isLoading={
          modelsLoader.isInitialLoading || configLoader.isInitialLoading
        }
      />
    </Group>
  );
};
